import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class CreateReceiptApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/sapRecord/createReceipt',
      requesterInfo,
    })
  }

  public async createReceipt(Id: number): Promise<any> {
    this.props.url = `${this.props.url}?recordId=${Id}`
    return await this.postAsync<any>()
  }
}
